import axios from '../axiosConfig';
import React, { useEffect, useMemo, useState } from 'react';
import TimePicker from 'react-times';
// use material theme
import 'react-times/css/material/default.css';
import { arreglarReloj, handleError, toastError, toastSuccess, toastWarningUnique } from '../funciones';
import FormInput from './FormInput';

// or you can use classic theme
//import 'react-times/css/classic/default.css';

export const ModalAgregarMesa = ({ inscripcion, empresa, evento, updateInscription }) => {

    const [mesa, setMesa] = useState("");
    const [reload, setReload] = useState(0);
    const paramsEventoTurno = useMemo(() => ({
        params: { eventoId: evento.id }
    }), [evento.id]);

    /*const [paramsEventoTurno, setParamsEventoTurno] = useState({
        params: {
            eventoId: evento.id
        }
    });*/

    function quitarMesaFija() {

        var params = {
            params: {
                inscripcionId: inscripcion.id,
            }
        }
        axios
            .put(process.env.REACT_APP_URL + 'inscripcion/eliminarMesaFija', null, params)
            .then((res) => {
                document.getElementById("btnCloseUnion").click();
                setReload(reload + 1)
                updateInscription(inscripcion.id, { numeroDeMesaReservada: null });
                toastSuccess("Mesa fija removida")
            })
            .catch(function (error) {
                toastError(handleError(error))
            })
    }

    function crearMesaFija() {

        if (mesa === "") {
            toastError("Debe seleccionar una mesa válida")
        }

        else {
            var params = {
                params: {
                    inscripcionId: inscripcion.id,
                    numeroMesa: mesa
                }
            }
            axios
                .put(process.env.REACT_APP_URL + 'inscripcion/agregarMesaFija', null, params)
                .then((res) => {
                    document.getElementById("btnCloseUnion").click();
                    setReload(reload + 1)
                    updateInscription(inscripcion.id, { numeroDeMesaReservada: mesa });
                    toastSuccess("Mesa fijada")
                })
                .catch(function (error) {
                    toastError(handleError(error))
                })
        }
    }

    function cerrarModal() {
        if (parseInt(localStorage.getItem(process.env.REACT_APP_DESDE_PERFIL)) === 1) {
            localStorage.removeItem(process.env.REACT_APP_DESDE_PERFIL);
            document.getElementById('abrirPerfil').click();
        }
    }

    return (
        <>

            <div class="modal fade " id="modalMesaFija" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered ">
                    <div class="modal-content rounded-4 modal-inscripciones">

                        <div class="modal-body p-0">
                            <button type="button" id='btnCloseUnion' class="btn-close btn-close-modal" data-bs-dismiss="modal" aria-label="Close"
                                onClick={cerrarModal}></button>
                            <button id="abrirPerfil" class="d-none" data-bs-toggle="modal"
                                data-bs-target="#modalPerfil" />
                            <div className='container px-5 py-4'>
                                <div className='row'>
                                    <div className='col'>
                                        <h2 className='text-color-principal titulos text-center'>Mesa Fija</h2>
                                    </div>
                                </div>
                                <div className='row mt-4'>
                                    <label class="form-label letraDatos">Empresa:
                                        <div className='ms-2 d-inline-block'>{empresa.nombre}</div>
                                    </label>
                                </div>
                                {inscripcion.numeroDeMesaReservada !== null &&
                                    <div className='row mt-2'>
                                        <label class="form-label letraDatos">Mesa fija actual:
                                            <div className='ms-2 d-inline-block'>{inscripcion.numeroDeMesaReservada}</div>
                                        </label>
                                    </div>
                                }
                                <div className='row mt-2'>
                                    <FormInput id={"mesasFijas"} text={"Seleccione la mesa:"} className={"col-12 w-lista-100"}
                                        mostrarTodas={false} setValue={setMesa} value={mesa} reload={reload}
                                        idSeccion={8} isText={true} url={"evento/mesasDeUnEventoNoAsignadas"}
                                        params={paramsEventoTurno}
                                    />
                                </div>
                                <div className='text-center py-2 gap-2 row flex-column  justify-content-center mt-4 '>
                                    <div className='col-2 w-auto p-0'>
                                        <button class="btn colorPrincipal text-white bold-botones btn-cuadrado" type="submit" onClick={crearMesaFija}>
                                            Fijar mesa
                                        </button>
                                    </div>
                                    {inscripcion.numeroDeMesaReservada !== null &&
                                        <div className='col-2 w-auto p-0 mt-2'>
                                            <button class="btn btn-outline-primary bold-botones btn-cuadrado  border-0" type="submit" onClick={quitarMesaFija}>
                                                Remover mesa fija
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>

    );
}